import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { Grid, Typography, Fade, CircularProgress } from '@material-ui/core';

import formatDate from '@lc/lib/helpers/formatDate';
import { Avatar } from '@lc/legacy/src/Components';

import api from 'api';
import clsx from 'clsx';

const RatingModalMobile = ({ classes, rating, room }) => {
  const { t } = useTranslation(['rating']);
  const [fetching, setFetching] = useState(false);
  const [comments, setComments] = useState([]);

  const fetchingComments = async () => {
    setFetching(true);
    const [commentsFetch] = await api.getAdvertisingComments(room);
    setComments(commentsFetch);
    setFetching(false);
  };

  useEffect(() => {
    fetchingComments();
  }, []);

  return (
    <Grid container item xs={12}>
      <Grid container item md={4} xs={12}>
        <Grid container item md={6} xs={12} style={{ maxHeight: '180px' }}>
          {rating.reviews.map(review => (
            <Grid container key={`${review.name}_${new Date().getTime()}`}>
              <Grid item md={8} xs={7}>
                <Typography variant="button" color="textPrimary" className={classes.title}>
                  {t(review.name)}
                </Typography>
              </Grid>
              <Grid item md={4} xs={5}>
                <Grid container item xs={12} alignItems="center">
                  <Grid item md={8} xs={10} className={classes.percentage}>
                    <div style={{ width: `${(review.rating * 100) / 5}%` }} />
                  </Grid>
                  <Grid item md={4} xs={2} className={classes.value}>
                    <Typography variant="button" color="textPrimary" className={classes.text}>
                      {review.rating.toFixed(1)}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>

      <Grid container item md={8} xs={12} style={{ marginTop: '25px' }}>
        <Grid item xs={12} style={{ overflowY: 'scroll', height: '440px', paddingLeft: '5px' }}>
          <Fade in={fetching}>
            <div className={clsx(classes.container, !fetching && classes.hide)}>
              <CircularProgress color="secondary" />
            </div>
          </Fade>
          {!fetching &&
            comments.map(comment => (
              <Grid key={comment.date} item xs={12} style={{ marginBottom: '30px' }}>
                <Grid container item xs={12} style={{ minWidth: '45px', maxHeight: '50px' }}>
                  <Grid item xs={2}>
                    <Avatar
                      src={comment.avatar}
                      alt="avatar"
                      type="small"
                      style={{ marginTop: '4px', paddingLeft: '1px', marginLeft: '0' }}
                    />
                  </Grid>
                  <Grid item xs={10} style={{ maxHeight: '50px' }}>
                    <Grid item xs={12}>
                      <Typography
                        variant="button"
                        color="textPrimary"
                        style={{ fontWeight: 600, fontSize: '12px' }}
                      >
                        {comment.booker}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography
                        variant="button"
                        color="textSecondary"
                        style={{ fontWeight: 500, fontSize: '11px' }}
                      >
                        {formatDate(comment.date, 'MMMM YYYY')}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} style={{ marginTop: '10px' }}>
                  <Typography variant="button" color="textPrimary">
                    {comment.comments}
                  </Typography>
                </Grid>
              </Grid>
            ))}
        </Grid>
      </Grid>
    </Grid>
  );
};

RatingModalMobile.propTypes = {
  classes: PropTypes.object.isRequired,
  rating: PropTypes.object.isRequired,
  room: PropTypes.string.isRequired,
};

const styles = () => ({
  container: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column',
  },
  hide: {
    display: 'none',
  },
  wrapper: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  text: {
    fontWeight: 600,
    fontSize: '12px',
  },
  value: {
    textAlignLast: 'end',
  },
  comments: {
    fontSize: '14px',
    marginTop: '10px',
    height: '40px',
    overflow: 'hidden',
    display: '-webkit-box',
    webkitLineClamp: '2',
    webkitBoxOrient: 'vertical',
  },
  more: {
    paddingTop: '3px',
    fontWeight: 600,
    textDecoration: 'underline',
    cursor: 'pointer',
    userSelect: 'none',
  },
  percentage: {
    backgroundColor: '#e9e9e9',
    '& > div': {
      backgroundColor: '#383838',
      height: '2px',
    },
  },
});

export default withStyles(styles)(RatingModalMobile);
